import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconGuaranteedSatisfaction = deprecatedComponent({
    displayName: 'IconGuaranteedSatisfaction',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("path", {
            d: "M17.0842 10.696C17.3448 10.3741 17.8171 10.3244 18.139 10.5851C18.4609 10.8458 18.5105 11.3181 18.2498 11.64L17.0842 10.696ZM10.1443 14.0392C9.84724 13.7505 9.84046 13.2756 10.1291 12.9786C10.4178 12.6816 10.8926 12.6748 11.1897 12.9635L10.1443 14.0392ZM13.6989 16.0678L14.2817 16.5398L13.6989 16.0678ZM13.3304 16.0897L13.8531 15.5519L13.3304 16.0897ZM18.2498 11.64L14.2817 16.5398L13.1161 15.5957L17.0842 10.696L18.2498 11.64ZM12.8077 16.6276L10.1443 14.0392L11.1897 12.9635L13.8531 15.5519L12.8077 16.6276ZM14.2817 16.5398C13.9117 16.9967 13.2293 17.0373 12.8077 16.6276L13.8531 15.5519C13.6423 15.347 13.3011 15.3673 13.1161 15.5957L14.2817 16.5398Z",
            fill: "black"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M17.8552 4.63962C17.8832 4.65332 17.9121 4.66526 17.9415 4.67537L21.2473 5.80909C21.6123 5.93427 21.8991 6.22099 22.0242 6.58599L23.158 9.89179C23.1681 9.92128 23.18 9.9501 23.1937 9.9781L24.7296 13.1173C24.8992 13.4639 24.8992 13.8694 24.7296 14.216L23.1937 17.3552C23.18 17.3832 23.1681 17.4121 23.158 17.4415L22.0242 20.7473C21.8991 21.1123 21.6123 21.3991 21.2473 21.5242L17.9415 22.658C17.9121 22.6681 17.8832 22.68 17.8552 22.6937L14.716 24.2296C14.3694 24.3992 13.9639 24.3992 13.6173 24.2296L10.4781 22.6937C10.4501 22.68 10.4213 22.6681 10.3918 22.658L7.08599 21.5242C6.72099 21.3991 6.43427 21.1123 6.30909 20.7473L5.17537 17.4415C5.16526 17.4121 5.15332 17.3832 5.13962 17.3552L3.60373 14.216C3.43415 13.8694 3.43415 13.4639 3.60373 13.1173L5.13962 9.9781C5.15332 9.9501 5.16526 9.92128 5.17537 9.89179L6.30909 6.58599C6.43427 6.22099 6.72099 5.93427 7.08599 5.80909L10.3918 4.67537C10.4213 4.66526 10.4501 4.65332 10.4781 4.63962L13.6173 3.10373C13.9639 2.93415 14.3694 2.93415 14.716 3.10373L17.8552 4.63962Z",
            stroke: "black",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconGuaranteedSatisfaction };
